import { useState } from "react";
import FlatSelectorModal from "../modals/FlatSelectorModal";
import BuildingIcon from "../../../../assets/icons/maid-module-icons/buildings.svg";
import ServiceStaffModal from "../modals/ServiceStaffModal";

const AddFlat = ({
  selectedFlats,
  setSelectedFlats,
  setIsFlatSelectorOpen,
}) => {
  const [showSelector, setShowSelector] = useState(false);
  const [showStaffModal, setShowStaffModal] = useState(false);

  const handleModalContinue = (flats) => {
    setSelectedFlats(flats);
    setShowSelector(false);
    setIsFlatSelectorOpen(false);
  };

  const removeFlat = (flatId) => {
    setSelectedFlats((prev) => prev.filter((f) => f.flatId !== flatId));
  };

  const handleContinueClick = () => {
    if (selectedFlats.length > 0) {
      setShowStaffModal(true);
    }
  };

  if (showSelector) {
    return (
      <FlatSelectorModal
        initialSelected={selectedFlats}
        onBack={() => {
          setShowSelector(false);
          setIsFlatSelectorOpen(false);
        }}
        onContinue={handleModalContinue}
      />
    );
  }

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
       {/* <h6 style={{ textAlign: "center", fontWeight: 700, marginBottom: 20 }}>
          Add Flat
        </h6> */}
              <div className="d-flex justify-content-center mb-3">
    <label className="form-label fw-bold mb-2">Add Flats</label>

  </div>

        <label style={{ fontWeight: 600, marginBottom: 8 }}>Search Flat</label>

        {/* Selector Box  */}
        <div
          onClick={() => {
            setShowSelector(true);
            setIsFlatSelectorOpen(true);
          }}
          style={{
            border: "1.5px solid #e0e0e0",
            borderRadius: 12,
            padding: 16,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <img src={BuildingIcon} alt="building" width={20} />
          <span style={{ color: "#1C80D2", fontWeight: "600" }}>Add Flats</span>
        </div>

        {/* Selected flats */}
        {selectedFlats.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 12 }}>
            {selectedFlats.map((flat) => (
              <div
                key={flat.flatId}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  background: "#1C80D2",
                  color: "#fff",
                  borderRadius: 6,
                  padding: "6px 10px",
                  fontWeight: 600,
                  fontSize: 14,
                  position: "relative",
                }}
              >
               {flat.towerName}-{flat.flatName}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    removeFlat(flat.flatId);
                  }}
                  style={{
                    position: "absolute",
                    top: -8,
                    right: -8,
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    border: "2px solid #fff",
                    background: "#e53935",
                    color: "#fff",
                    fontSize: 10,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                    lineHeight: 1,
                  }}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        )}
    </div>

      {/* Service Staff Modal */}
      <ServiceStaffModal show={showStaffModal} onHide={() => setShowStaffModal(false)} />
    </>
  );
};

export default AddFlat;